export default __webpack_public_path__ + "static/media/nem.a490a0b8.png";